import getConfiguredAppAxiosWithCtx from '../../../functions/getConfiguredAppAxiosWithCtx';
import { appAxios } from '../core/appAxiosService';
import secretApiAxios from '../core/secretApiAxios';

export const GetInformationService = async (ctx) => {
  var appAxiosCtx = getConfiguredAppAxiosWithCtx(appAxios, ctx);

  return await appAxiosCtx
    .get(process.env.NEXT_PUBLIC_APP_API_URI_GET_INFORMATION, {})
    .then((data) => {
      return data.data;
    })
    .catch((err) => {
      return { error: 'Erro de comunicação' };
    });
};

export const GetInfos = async () => {
  return await secretApiAxios
    .get('infos?populate=*')
    .then((data) => {
      return data.data;
    })
    .catch((err) => {
      return { error: 'Erro de comunicação', err };
    });
};
